import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/gateways/mercado_pago.png")